export const businessDirecProps = {
  "companyProfilesSearchValue": "",
  "countryCode": "de",
  "env": "dev",
  // "isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage": true,
  "isSearchOverlay": true,
  "isSearchOverlayAndNotUnitedStates": false,
  "isSearchOverlayOpen": false,
  "isSiteSearchResultsPage": false,
  "resourcePath": "/content/dnb-de/de/startseite/firmenverzeichnis/jcr:content/content-par/singlepagesearch",
  // "searchInput": "",
  "singlePageSearchData": {
      "allLocalized": "Alle",
      "businessDirectoryLocalized": "Firmenverzeichnis",
      "businessDirectoryPath": "/firmenverzeichnis.html",
      "businessDirectoryPathRewritten": "/de-de/firmenverzeichnis.html",
      "companyNameLocalized": "Firmenname",
      "companyprofilesLocalized": "Firmenprofile",
      "companyprofileLocalized": "Firmenprofil",
      "companyResultsLocalized": "Firmenergebnisse anzeigen",
      "compareProductsOtherBusinessPathRewritten": "/products/small-business/compare-products-other-business.html",
      "contactDirectoryPathRewritten": "/contact-directory.html",
      "currentPageAbsoluteParentTwoPagePath": "/content/dnb-de/de",
      "currentPagePath": "/content/dnb-de/de/startseite/firmenverzeichnis.html",
      "dandbBusinessDirectoryLocalized": "D&B Firmenverzeichnis",
      "homeLocalized": "Startseite",
      "errorHandlerPath": "/startseite/errorhandler/",
      "industryLocalized": "Branche",
      "locationLocalized": "Standort",
      "locationTypeLocalized": "Standorttyp",
      "makeSureSpelledLocalized": "Vergewissern Sie sich, dass Sie Ihren Suchbegriff richtig geschrieben haben.",
      "refineYourSearchLocalized": "Verfeinern Sie Ihre Suche",
      "clearAllLocalized": "Alle löschen",
      "filterByLocalized": "Filtern",
      "searchLocalized": "Suche",
      "searchhereLocalized": "Hier suchen…",
      "previousLocalized": "Zurück",
      "nextLocalized": "Weiter",
      "noSearchResultsSiteContentPrefix": "Es gibt keine Suchergebnisse für",
      "noSearchResultsSiteContentSuffix": "innerhalb von der Website-Inhalte.",
      "searchResultsInCompanyProfilesLocalized": "Suchergebnisse im Firmenverzeichnis",
      "searchResultsInPas": "Suchergebnisse in Produkten, Artikeln und Website-Inhalten",
      "searchthedunandbradstreetcloudLocalized": "Dun & Bradstreet Cloud durchsuchen",
      "seeAllLocalized": "Alle",
      "selectEntityType": "Standorttyp auswählen",
      "selectNumberOfEmployeesLocalized": "Anzahl der Mitarbeiter auswählen",
      "siteContentResultsLocalized": "Ergebnisse für Website-Inhalte anzeigen",
      "showMoreLocalized": "Mehr anzeigen",
      "readMoreLocalized": "Mehr lesen",
      "siteSearchPath": "/content/dnb-de/de/startseite/seitensuche",
      "siteSearchPathRewritten": "/de-de/seitensuche.html",
      "siteSearchResultsPath": "/content/dnb-de/de/startseite/seitensuche-ergebnisse.html",
      "siteSearchResultsPathRewritten": "/de-de/firmenverzeichnis.html",
      "sitecontentLocalized": "Seiteninhalt",
      "thereAreNoResultsForLocalized": "Es gibt keine Suchergebnisse für",
      "topResultsInCompanyProfile": "Top-Ergebnisse im Firmenverzeichnis",
      "topResultsInPas": "Top-Ergebnisse in Produkten, Artikeln und Website-Inhalten",
      "topResultsLocalized": "Top-Ergebnisse",
      "tryFewerLocalized": "Versuchen Sie es mit weniger Suchbegriffen.",
      "typeAheadDontSeeCompanyLocalized": "Ist Ihr Unternehmen nicht dabei?",
      "typeAheadGetDunsNumberLocalized": "Beantragen Sie eine D-U-N-S Nummer",
      "typeAheadGetDunsNumberLinkLocalized": "https://www.dnb.com/de-de/duns-request",
      "typeAheadNoResultsFoundLocalized": "Es wurden leider keine Ergebnisse im Firmenverzeichnis gefunden. ",
      "withinCompanyProfilesLocalized": "innerhalb des Firmenverzeichnisses.",
      "businessCreditReportsLabelLocalized": "D&B Kreditauskunft kaufen",
      "businessCreditReportsLinkLocalized": "https://www.dnb.com/de-de/firmensuche/das-datenuniversum/",
      "useAddSearch": false,
      "addSearchPublicSiteKey": ""
  },
  "token": "eyJwNCI6ImVUVnZwbHBlOGhzdjJoS0gxTnp4RUdNRk9HSE9KTkpLS0wiLCJwMiI6NSwicDMiOjM0LCJwMSI6MTcwOTEyOTQ4NDU1Nn0=",
  "inTabAll": false
}